const errors = {
  TIMEOUT: 'El tiempo de espera se ha terminado. Inténtelo nuevamente.',
  LIVENESS: 'Esto puede deberse a que el tiempo de espera terminó o que el umbral de vida no fué superado. Inténtalo nuevamente.',
  OTP: 'Se han agotado el número máximo de intentos disponibles para la verificación del OTP. Inténtalo nuevamente.',
};

export default errors;
